module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#intro",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WHAT IS AMERICAN FOLK ART?")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TOOLS & MATERIALS")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PAINTING TECHNIQUES")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PERSPECTIVE & THE NAÏVE STYLE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("DRAWING EXERCISE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CREATING A COLOR PALETTE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PAINTING PROJECTS")])]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WILDFLOWER STILL LIFE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SONGBIRD")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WASH DAY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE CAKE SHOP")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WELCOME HOME PINEAPPLE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("LIGHTHOUSE BY THE SEA")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FLOWER COTTAGE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDEPENDENCE DAY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TREE OF LIFE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("YARN IT ALL")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PUMPKIN COVE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE PUMPKIN PATCH")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("CHRISTMAS DOVE")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SNOWY NIGHT")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("LET IT SNOW")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PEACE IN THE CITY")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INSPIRATION GALLERY")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/author#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ABOUT THE AUTHOR")])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden",
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Start of Content")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/xhtml/toc"
    }
  }, [_vm._v("Contents")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden",
    attrs: {
      "epub:type": "page-list"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/intro#page_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/intro#page_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#page_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch01#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#page_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/xhtml/author#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 60
// module chunks = 0